import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperFeatures = () => {
  new Swiper('.swiper-features', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 10,
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  });
};

export default swiperFeatures;
